import { useNavigate } from "react-router-dom";
import { Container, Card, Table, ButtonGroup, Button, Col, Form } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
  faMoneyBill, 
  faPenToSquare, 
  faHourglass,
  faCheck,
  faReply,
  faMinus,
  faClose
} from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment/moment";
import { getEmployeeApplicationPage, getLeaveApplicationListByUserID, updateCurrentPage, getApplicationListsCount } from "../../3.Store/ApplicationSlice";
import { useEffect, useState } from "react";
import { ThreeDots } from 'react-loader-spinner';
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Pagination from "../../2.Commons/Pagination";

const LeaveApplicationList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  const employee = JSON.parse(localStorage.getItem("current_user"));
  const userId = employee?.id;

  const { applicationLists } = useSelector((store) => store.ApplicationSlice);
  // const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 20; // Number of items per page
  const totalPages = useSelector((store) => store.ApplicationSlice.totalPages);
  const currentPage = useSelector((store) => store.ApplicationSlice.currentPage);

  useEffect(() => {
    setLoading(true);
    dispatch(getEmployeeApplicationPage({ id: userId, page: currentPage }))
      .then(() => {
        dispatch(getApplicationListsCount({ id: userId }));
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, [userId]);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleBtnBack = () => {
    navigate("/");
  };

  const handleBtnAdd = () => {
    navigate("/LeaveApplicationForm");
  };

  const handleBtnEdit = (id) => {
    navigate(`/LeaveApplicationForm/${id}`);
  };

  const handleBtnMedical = (leaveApplicationId) => {
    navigate(`/MedicalClaimForm/leave/${leaveApplicationId}`);
  };

  const handlePreviousPage = () => {
    setLoading(true);
    if (currentPage > 1) {
      dispatch(updateCurrentPage(currentPage - 1));
      dispatch(getEmployeeApplicationPage({id:userId, page:currentPage - 1}))
      .then(() => {
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
    }
  };

  const handleNextPage = () => {
    setLoading(true);
    if (currentPage < totalPages) {
      dispatch(updateCurrentPage(currentPage + 1));
      dispatch(getEmployeeApplicationPage({id:userId, page:currentPage + 1}))
      .then(() => {
          setLoading(false);
      })
      .catch(() => {
          setLoading(false);
      });
    }
  };

  const handlePageChange = (page) => {
    setLoading(true);
    dispatch(updateCurrentPage(page));
    if (page <= totalPages) {
      dispatch(getEmployeeApplicationPage({id:userId, page}))
      .then(() => {
          setLoading(false);
      })
      .catch(() => {
          setLoading(false);
      });
    }
  };

  const renderPaginationControls = () => (
    <>
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        handlePreviousPage={handlePreviousPage}
        handleNextPage={handleNextPage}
        handlePageChange={handlePageChange}
      />
    </>
  );

  const truncateText = (text, maxWords) => {
    if (!text) return '';
    const words = text.split(' ');
    if (words.length <= maxWords) return text;
    return words.slice(0, maxWords).join(' ') + '...';
  }

  return (
    <div className="ContainerContent2">
      {loading && (
        <ThreeDots
          visible={loading}
          height="80"
          width="80"
          color="#4fa94d"
          radius="9"
          ariaLabel="three-dots-loading"
          wrapperStyle={{
            position: 'fixed',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: '9999',
          }}
        />
      )}
      <Card className="CardContent">
        <h1 className="TitleHeader">Leave Applications</h1>
        <h1 className="MiniTitleHeader">List</h1>

        {renderPaginationControls()}

        <Table className="my-fixed-table" style={{ fontSize: "14px", cursor: "pointer" }}>
          <thead>
            <tr className="cursor-pointer fw-bold">
              {isMobile ? (
                <>
                  <th style={{ width: "60px" }}>Application</th>
                  <th style={{ width: "30px" }} className="text-center align-middle">Status</th>
                  <th style={{ width: "10px" }} className="text-center align-middle">Edit</th>
                </>
              ) : (
                <>
                  <th style={{ width: "80px" }}>Date</th>
                  <th style={{ width: "80px" }}>Type</th>
                  <th style={{ width: "70px" }}>No. of Days</th>   
                  <th style={{ width: "145px" }}>Date</th>  
                  <th style={{ width: "250px" }}>Reason</th>
                  <th style={{ width: "60px" }} className="text-center align-middle">Status</th>
                  <th style={{ width: "60px" }} className="text-center align-middle">
                    <FontAwesomeIcon icon={faMoneyBill} title="Medical Claim"/>
                  </th>
                  <th style={{ width: "60px" }} className="text-center align-middle">
                    <FontAwesomeIcon icon={faPenToSquare} title="Action"/>
                  </th>
                </>
              )}
            </tr>
          </thead>

          <tbody>
            {!loading && applicationLists.length > 0 ? (
              applicationLists.map(({ from_date, to_date, from_ampm, to_ampm, number_of_days, id, created, leave_type, description, reason_for_application, status }) => (
                <tr key={id} onClick={() => handleBtnEdit(id)} className="cursor-pointer">
                  {isMobile ? (
                    <>
                      <td className="text-truncate" style={{ maxWidth: "200px" }}>
                        <strong>{leave_type?.description} ({number_of_days}D)</strong>
                        <br />
                        <strong>From:</strong> {moment(from_date.date).format("YYYY-MM-DD")} ({from_ampm})
                        <br />
                        <strong>To:</strong> {moment(to_date.date).format("YYYY-MM-DD")} ({to_ampm})
                        <br />
                        <span title={reason_for_application}>{reason_for_application}</span>
                      </td>
                      <td className="text-center align-middle">
                        <OverlayTrigger placement="top" overlay={<Tooltip>{status?.short_description}</Tooltip>}>
                          <span>
                            {status?.short_description === "PENDING" && (
                              <FontAwesomeIcon icon={faHourglass} color="#FFC107" />
                            )}
                            {status?.short_description === "APPROVED" && (
                              <FontAwesomeIcon icon={faCheck} color="#28A744" />
                            )}
                            {status?.short_description === "APPROVED-HR" && (
                              <FontAwesomeIcon icon={faCheck} color="#28A744" />
                            )}
                            {status?.short_description === "REJECTED-SUPERVISOR" && (
                              <FontAwesomeIcon icon={faClose} color="#DC3545" />
                            )}
                            {status?.short_description === "REJECTED-HR" && (
                              <FontAwesomeIcon icon={faClose} color="#DC3545" />
                            )}
                            {status?.short_description === "DELETED" && (
                              <FontAwesomeIcon icon={faMinus} color="#FFC107" />
                            )}
                            {status?.short_description === "WITHDRAWN (HR)" && (
                              <FontAwesomeIcon icon={faReply} color="#28A744" />
                            )}
                            {status?.short_description === "REVERT" && (
                              <FontAwesomeIcon icon={faReply} color="#DC3545" />
                            )}
                            {status?.short_description === "WITHDRAWING" && (
                              <FontAwesomeIcon icon={faReply} color="#FFC107" />
                            )}
                            {status?.short_description === "WITHDRAWN" && (
                              <FontAwesomeIcon icon={faReply} color="#28A744" />
                            )}
                          </span>
                        </OverlayTrigger>
                      </td>
                      <td className="text-center align-middle">
                        <FontAwesomeIcon icon={faPenToSquare} className="text-primary" onClick={(e) => {
                          e.stopPropagation();
                          handleBtnEdit(id);
                        }}/>
                      </td>
                    </>
                  ) : (
                    <>
                      <td>{moment(created).format("YYYY-MM-DD")}</td>
                      <td>{leave_type?.description}</td>
                      <td>{number_of_days}</td>
                      <td>
                        {moment(from_date.date).isSame(moment(to_date.date), "day") ? (
                          <>
                            {moment(from_date.date).format("YYYY-MM-DD")}
                            {Number(number_of_days) === 0.5 && ` (${from_ampm})`}
                          </>
                        ) : (
                          // Spans multiple dates, e.g. today PM + tomorrow AM (1.0 day)
                          <>
                            {moment(from_date.date).format("YYYY-MM-DD")}
                            {from_ampm === "PM" && " (PM)"}
                            {" - "}
                            {moment(to_date.date).format("YYYY-MM-DD")}
                            {to_ampm === "AM" && " (AM)"}
                          </>
                        )}
                      </td>
                      <td>{reason_for_application}</td>
                      <td className="text-center align-middle">
                        <OverlayTrigger placement="top" overlay={<Tooltip>{status?.short_description}</Tooltip>}>
                          <span>
                            {status?.short_description === "PENDING" && (
                              <FontAwesomeIcon icon={faHourglass} color="#FFC107" />
                            )}
                            {status?.short_description === "APPROVED" && (
                              <FontAwesomeIcon icon={faCheck} color="#28A744" />
                            )}
                            {status?.short_description === "APPROVED-HR" && (
                              <FontAwesomeIcon icon={faCheck} color="#28A744" />
                            )}
                            {status?.short_description === "REJECTED-SUPERVISOR" && (
                              <FontAwesomeIcon icon={faClose} color="#DC3545" />
                            )}
                            {status?.short_description === "REJECTED-HR" && (
                              <FontAwesomeIcon icon={faClose} color="#DC3545" />
                            )}
                            {status?.short_description === "DELETED" && (
                              <FontAwesomeIcon icon={faMinus} color="#FFC107" />
                            )}
                            {status?.short_description === "WITHDRAWN (HR)" && (
                              <FontAwesomeIcon icon={faReply} color="#28A744" />
                            )}
                            {status?.short_description === "WITHDRAWN" && (
                              <FontAwesomeIcon icon={faReply} color="#28A744" />
                            )}
                            {status?.short_description === "WITHDRAWING" && (
                              <FontAwesomeIcon icon={faReply} color="#FFC107" />
                            )}
                            {status?.short_description === "REVERT" && (
                              <FontAwesomeIcon icon={faReply} color="#DC3545" />
                            )}
                          </span>
                        </OverlayTrigger>
                      </td>
                      <td className="text-center align-middle">
                        {leave_type?.description === "Sick Leave" && (
                          <FontAwesomeIcon
                            icon={faMoneyBill}
                            // onClick={() => handleBtnMedical(id)}
                            onClick={(e) => {
                              e.stopPropagation(); // prevent row click
                              handleBtnMedical(id);
                            }}
                          />
                        )}
                      </td>
                      <td className="text-center align-middle">
                        <FontAwesomeIcon icon={faPenToSquare} className="text-primary" onClick={(e) => {
                          e.stopPropagation();
                          handleBtnEdit(id);
                        }}/>
                      </td>
                    </>
                  )}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={isMobile ? "3" : "8"}>No results found</td>
              </tr>
            )}
          </tbody>
        </Table>

        <div className="legend-pagination-row">
          <div className="legend-container overflow-auto">
            <div className="legend-grid-two-rows">
              <span className="legend-item2">
                <FontAwesomeIcon icon={faHourglass} color="#FFC107" />&nbsp;Pending
              </span>
              <span className="legend-item2">
                <FontAwesomeIcon icon={faReply} color="#28A744" />&nbsp;Withdrawn
              </span>
              <span className="legend-item2">
                <FontAwesomeIcon icon={faMinus} color="#FFC107" />&nbsp;Deleted
              </span>
              <span className="legend-item2">
                <FontAwesomeIcon icon={faReply} color="#FFC107" />&nbsp;Withdrawing
              </span>
              <span className="legend-item2">
                <FontAwesomeIcon icon={faClose} color="#DC3545" />&nbsp;Rejected
              </span>
              <span className="legend-item2">
                <FontAwesomeIcon icon={faReply} color="#DC3545" />&nbsp;Withdrawal Rejected
              </span>
              <span className="legend-item2">
                <FontAwesomeIcon icon={faCheck} color="#28A744" />&nbsp;Approved
              </span>
            </div>
          </div>

          <div className={`ms-auto ${isMobile ? 'mt-2' : ''}`}>
            {renderPaginationControls()}
          </div>

        </div>

        <div className="d-flex justify-content-between">
          <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnBack}>
              Back
            </Button>
          </ButtonGroup>
          <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnAdd}>
              Add
            </Button>
          </ButtonGroup>
        </div>
      </Card>
    </div>
  );
};

export default LeaveApplicationList;